import React, {useState, useEffect} from "react";
import { Modal, Button, Spin } from "antd";
import { DownloadOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import {isImageUrl} from "utils/helpers";

export const ViewContractFileModal = ({
    visible,
    onCancel,
    documentUrl,
    documentType,
    loading,
    files
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (visible) setCurrentIndex(0);
    }, [visible, files]);

    const isMultiMode = Array.isArray(files) && files.length > 0;
    const activeUrl = isMultiMode ? files[currentIndex]?.path : documentUrl;
    const isImage = isMultiMode ? isImageUrl(activeUrl) : documentType?.startsWith('image/');
    const totalFiles = isMultiMode ? files.length : 1;

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = activeUrl;
        link.download = (isMultiMode ? files[currentIndex]?.name : null) || 'sozlesme-dosyasi';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const buildFooter = () => {
        if (loading) return null;

        const downloadBtn = (
            <Button key="download" type="primary" icon={<DownloadOutlined />} onClick={handleDownload}>
                İndir
            </Button>
        );

        if (!isMultiMode || totalFiles <= 1) {
            return [downloadBtn];
        }

        return (
            <div style={{display: "flex", alignItems: "center", width: "100%"}}>
                <div style={{flex: 1}} />
                <div style={{display: "flex", alignItems: "center", gap: 12}}>
                    <Button
                        icon={<LeftOutlined />}
                        onClick={() => setCurrentIndex(i => i - 1)}
                        disabled={currentIndex === 0}
                    />
                    <span style={{lineHeight: "32px"}}>
                        {currentIndex + 1} / {totalFiles}
                    </span>
                    <Button
                        icon={<RightOutlined />}
                        onClick={() => setCurrentIndex(i => i + 1)}
                        disabled={currentIndex === totalFiles - 1}
                    />
                </div>
                <div style={{flex: 1, display: "flex", justifyContent: "flex-end"}}>
                    {downloadBtn}
                </div>
            </div>
        );
    };

    const modalTitle = isMultiMode && totalFiles > 1
        ? `Sözleşme Dosyası (${currentIndex + 1}/${totalFiles})`
        : "Sözleşme Dosyası";

    return (
        <Modal
            title={modalTitle}
            visible={visible}
            onCancel={onCancel}
            footer={buildFooter()}
            width={800}
            style={{top: 50}}
            bodyStyle={{
                padding: 0,
                height: "600px"
            }}
            destroyOnClose
        >
            {loading ? (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    <Spin size="large" tip="Dosya yükleniyor..." />
                </div>
            ) : (
                isImage ? (
                    <img
                        key={activeUrl}
                        src={activeUrl}
                        alt="Sözleşme Dosyası"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain"
                        }}
                    />
                ) : (
                    <iframe
                        key={activeUrl}
                        src={activeUrl}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none"
                        }}
                        title="Sözleşme Dosyası"
                    />
                )
            )}
        </Modal>
    );
};